export const API_URL = process.env.REACT_APP_API_URL || '/api';

export const LANDING_PAGE = '/';
export const DASHBOARD_PAGE = '/dashboard';
export const CITY_COMPARISON_PAGE = '/city_comparison';
